import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-financial-history',
  templateUrl: './financial-history.component.html'
})
export class FinancialHistoryComponent  {
  @Input() accountClientHistory: any[] = [];
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/financial-history/financial-history.component.ts